import { cva, type VariantProps } from 'class-variance-authority';
export { default as PSelect } from './PSelect.vue';
export { default as PSelectContent } from './PSelectContent.vue';
export { default as PSelectGroup } from './PSelectGroup.vue';
export { default as PSelectItem } from './PSelectItem.vue';
export { default as PSelectItemText } from './PSelectItemText.vue';
export { default as PSelectLabel } from './PSelectLabel.vue';
export { default as PSelectScrollDownButton } from './PSelectScrollDownButton.vue';
export { default as PSelectScrollUpButton } from './PSelectScrollUpButton.vue';
export { default as PSelectSeparator } from './PSelectSeparator.vue';
export { default as PSelectTrigger } from './PSelectTrigger.vue';
export { default as PSelectValue } from './PSelectValue.vue';

export const pSelectTriggerCva = cva('', {
    variants: {
        size: {
            sm: 'h-8 px-2 py-1.5',
            default: 'h-9 pl-3 pr-2 py-2',
            lg: 'h-10 pl-4 pr-2 py-2.5',
        },
    },
    defaultVariants: {
        size: 'default',
    },
});

export type PSelectTriggerVariants = VariantProps<typeof pSelectTriggerCva>;
